import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from 'react';
import SummaryApi from './common';
import Context from './context';
import { useDispatch, useSelector } from 'react-redux';
import { Suspense, lazy } from "react";
import ProtectedRoutes from "./routes/ProtectedRoutes";
import PublicRoutes from "./routes/PublicRoutes";
import axios from 'axios';
import { authHeader } from './helpers/auth-header';
import ToastManager from './common/ToastManager.js';
import SonnerToastManager from "./common/SonnerToastManager.js"
import Loading from './common/Loading.js';
import WalletOverview from './pages/Wallet.js';
import useAuth from "../src/hooks/useAuth.js"
import GlobalProvider from './context/GlobalContext.js';
import { WishlistProvider } from './context/WishlistContext.js';
import { ThemeProvider } from './context/ThemeContext.js';
import { NotificationProvider } from './context/NotificationContext.js';
import { fetchCart } from './store/cartSlice.js';
import WinnerDetails from './pages/WinnerDetails.js';
import InstallPrompt from "./components/InstallPrompt";

import { toast } from 'sonner';
import LoginModal from './components/LoginModal.jsx';
import LoginPromptProvider from './context/LoginPromptContext.jsx';
import PincodeModal from './components/PincodeModal.jsx';
import ScrollToTop from './components/ScrollToTop.js';
import BackToTop from './components/BackToTop.js';
import BottomNavigation from './components/BottomNavigation.js';
import ScrollProgress from './components/ScrollProgress.js';
import ReminderPopupsManager from './components/ReminderPopupsManager.js';
import { utils } from './common/utils';
import ComingSoon from './components/ComingSoon';
import CategorySidebar from './components/CategorySidebar';
import { HiBars3 } from "react-icons/hi2";
import { MdClose } from "react-icons/md";

const Home = lazy(() => import("./pages/Home"));
const Login = lazy(() => import('./pages/Login'))
const SignUp = lazy(() => import('./pages/SignUp'))
const ProductDetails = lazy(() => import('./pages/ProductDetails'))
const Cart = lazy(() => import("./pages/Cart"))
const Order = lazy(() => import("./pages/Order"))
const OrderDetailsPage = lazy(() => import("./pages/OrderDetailsPage"))
const About = lazy(() => import("./pages/About.js"))
const HowtoUse = lazy(() => import("./pages/HowtoUse.js"))
const OrderSummary = lazy(() => import("./pages/OrderSummary.js"))
const CategoryProduct = lazy(() => import("./pages/CategoryProduct"));
const PageNotFound = lazy(() => import("./pages/PageNotFound.js"))
const ResetPassword = lazy(() => import("./pages/ResetPassword.js"))
const ForgotPassowrd = lazy(() => import('./pages/ForgotPassowrd'))
const SearchResultsPage = lazy(() => import('./pages/SearchProduct.js'))
const ContactUsPage = lazy(() => import("./pages/ContactUsPage"))
const ProfileManagement = lazy(() => import("./pages/ProfileManagement.js"))
const LeaderboardPreview = lazy(() => import("./pages/LeaderboardPreviewPage.js"))
const VerifyEmailOtp = lazy(() => import("./pages/EmailVerfication.js"))
const HelpCenter = lazy(() => import("./pages/HelpCenter.js"))
const ShippingInfo = lazy(() => import("./pages/ShippingInfo.js"))
const ReturnsRefunds = lazy(() => import("./pages/ReturnsRefunds.js"))
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy.js"))
const TermsConditions = lazy(() => import("./pages/TermsConditions.js"))
const Wishlist = lazy(() => import("./pages/Wishlist.js"))
const Notifications = lazy(() => import("./pages/Notifications.js"))
const Game = lazy(() => import("./pages/Game.js"))
const Notes = lazy(() => import("./pages/Notes.js"))
const Compass = lazy(() => import("./pages/Compass.js"))
const CalculatorPage = lazy(() => import("./pages/CalculatorPage.js"))
const CalendarPage = lazy(() => import("./pages/CalendarPage.js"))
const ReferralDashboard = lazy(() => import("./pages/ReferralDashboard.js"))
const Chat = lazy(() => import("./pages/Chat.js"))

function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  let { user: isLoggedIn, user: currentUser } = useSelector(
    (state) => state?.user
  );
  const { isAuthenticated, user, isBusiness } = useAuth();
  const [showPincodeModal, setShowPincodeModal] = useState(false);
  const [isCategorySidebarOpen, setIsCategorySidebarOpen] = useState(false);
  
  // Hide footer on chat page
  const hideFooter = location.pathname === '/chat';


  useEffect(() => {
    setTimeout(() => {
      const justLoggedIn = localStorage.getItem("justLoggedIn");
      // B2B users skip the pincode modal — their delivery areas are managed by the business.
      if (justLoggedIn === "true" && currentUser?.email && !isBusiness) {
        setShowPincodeModal(true);
      }
    }, 2000)
  }, [currentUser, isBusiness]);


  useEffect(() => {
    if (isAuthenticated) {
      setTimeout(() => {
        dispatch(fetchCart());
      }, 500)
    }
    // toast.success("Campaign loaded successfully!");
    // toast.error("Failed to load campaign");
  }, [dispatch, isAuthenticated]);

  // Close mobile category sidebar on navigation.
  useEffect(() => {
    setIsCategorySidebarOpen(false);
  }, [location.pathname, location.search]);

  // Check if Coming Soon mode is enabled
  if (utils?.comingSoon) {
    return <ComingSoon />;
  }

  return (
    <>
      <ThemeProvider>
        <GlobalProvider>
          <WishlistProvider>
            <NotificationProvider>
          <PincodeModal
            isOpen={showPincodeModal}
            setIsOpen={setShowPincodeModal}
            currentUser={currentUser}
          />
          <LoginPromptProvider>

          <SonnerToastManager />
          <ScrollProgress />
          <Header />
          <main className='min-h-[calc(100vh-120px)] pt-14 pb-16 md:pb-0'>
            {/* pt-16, pb-16 for mobile bottom nav */}
                      <Suspense fallback={<Loading />}>
                        <ScrollToTop />
                        <BackToTop />
                        <InstallPrompt />
              {/* Mobile category toggle */}
              <button
                type="button"
                onClick={() => setIsCategorySidebarOpen(true)}
                className="md:hidden fixed left-3 top-20 z-[60] flex items-center gap-2 px-3 py-2 rounded-xl bg-white border border-gray-200 shadow-md text-gray-700 hover:text-orange-600 hover:bg-gray-50"
                aria-label="Open categories"
              >
                <HiBars3 className="text-lg" />
                <span className="text-sm font-semibold">Categories</span>
              </button>

              {/* Mobile category drawer */}
              {isCategorySidebarOpen && (
                <>
                  <div
                    className="fixed inset-0 bg-black/50 z-[55] md:hidden"
                    onClick={() => setIsCategorySidebarOpen(false)}
                    aria-hidden="true"
                  />
                  <aside className="fixed inset-y-0 left-0 w-80 max-w-[85vw] bg-white z-[56] shadow-2xl overflow-y-auto md:hidden">
                    <div className="p-4 border-b border-gray-200 flex items-center justify-between sticky top-0 bg-white z-10">
                      <h2 className="text-lg font-bold text-gray-900">Categories</h2>
                      <button
                        type="button"
                        onClick={() => setIsCategorySidebarOpen(false)}
                        className="w-9 h-9 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors"
                        aria-label="Close categories"
                      >
                        <MdClose className="text-xl text-gray-700" />
                      </button>
                    </div>
                    <div className="p-4">
                      <CategorySidebar showTitle={false} className="w-full !sticky top-0" />
                    </div>
                  </aside>
                </>
              )}
              <div className="flex gap-6">
                <div className="hidden md:block w-[210px] sm:w-[240px] shrink-0">
                  <CategorySidebar />
                </div>
                <div className="flex-1 min-w-0">
                  <Routes>
                    <Route element={<ProtectedRoutes isLoggedIn={isLoggedIn} />}>
                      <Route path="wallet" element={<WalletOverview />} />
                      <Route path="profile" element={<ProfileManagement />} />
                      <Route path="cart" element={<Cart />} />
                      <Route path="summary" element={<OrderSummary />} />
                      <Route path="order" element={<Order />} />
                      <Route path="order/:id" element={<OrderDetailsPage />} />
                      {/* <Route path="order/:id" element={<OrderDetailsPage />} /> */}
                      <Route path="reward/winner/preview" element={<LeaderboardPreview />} />
                      <Route path="/reward/winner/:id" element={<WinnerDetails />} />
                      <Route path="notifications" element={<Notifications />} />
                      <Route path="chat" element={<Chat />} />
                      <Route path="game" element={<Game />} />
                      <Route path="referral-dashboard" element={<ReferralDashboard />} />
                    </Route>
                    <Route element={<PublicRoutes isLoggedIn={isLoggedIn} />}>
                      <Route path="sign-up" element={<SignUp />} />
                      <Route path="login" element={<Login />} />
                      <Route path="verify-email" element={<VerifyEmailOtp />} />
                      <Route path="reset-password" element={<ForgotPassowrd />} />
                      <Route path="forgot-password" element={<ResetPassword />} />
                    </Route>
                    <Route path="/" element={<Home />} />
                    <Route path="/product/:id" element={<ProductDetails />} />
                    <Route path="/product-category" element={<CategoryProduct />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/how-to-use" element={<HowtoUse />} />
                    <Route path="/contact" element={<ContactUsPage />} />
                    <Route path="/search" element={<SearchResultsPage />} />
                    <Route path="/help-center" element={<HelpCenter />} />
                    <Route path="/shipping-info" element={<ShippingInfo />} />
                    <Route path="/returns-refunds" element={<ReturnsRefunds />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-conditions" element={<TermsConditions />} />
                    <Route path="/wishlist" element={<Wishlist />} />
                    <Route path="/notes" element={<Notes />} />
                    <Route path="/compass" element={<Compass />} />
                    <Route path="/calculator" element={<CalculatorPage />} />
                    <Route path="/calendar" element={<CalendarPage />} />
                    <Route path="*" element={<PageNotFound />} />
                  </Routes>
                </div>
              </div>
            </Suspense>
          </main>
          {!hideFooter && <Footer />}
          {!hideFooter && <BottomNavigation />}
          
          {/* Reminder Popups Manager - Must be inside WishlistProvider */}
          <ReminderPopupsManager />
        </LoginPromptProvider>
            </NotificationProvider>
          </WishlistProvider>
        </GlobalProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
